import { render, staticRenderFns } from "./AssetUploadButton.vue?vue&type=template&id=2a27f758&scoped=true"
import script from "./AssetUploadButton.vue?vue&type=script&lang=ts"
export * from "./AssetUploadButton.vue?vue&type=script&lang=ts"
import style0 from "./AssetUploadButton.vue?vue&type=style&index=0&id=2a27f758&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a27f758",
  null
  
)

export default component.exports